<ce-tile-basic
    [title]="notesText"
    (openDialog)="openTicketList()"
    [hideOpenDialogBtn]="!!locationId"
    [loading]="loading"
>
    <ng-container tile-content>
        <ce-ticket-list-small [tickets]="tickets" [stationId]="stationId"></ce-ticket-list-small>
        <div *ngIf="ticketsLoaded && tickets?.length === 0" translate>
            <div class="fx-align-start-center fx-layout-gap-8 fx-row">
                <mat-icon svgIcon="check" class="success"></mat-icon>
                <div i18n="Tile ticket title|">No notes available</div>
            </div>
        </div>
    </ng-container>
    <ng-container tile-footer>
        <div class="contact-support-text">
            <span i18n="Contact support|"> Contact Kempower Technical Support at </span>
            <a class="contact-support-link" href="https://kempower.com/support/" target="_blank"
                >https://kempower.com/support/</a
            >
        </div>
        <ng-container *ceAccess="'fleet.chargingStation.ticketing.write'">
            <button
                i18n="Button to create ticket|"
                *ngIf="stationId"
                mat-stroked-button
                class="full-size-btn"
                (click)="createNewTicket()"
                (keydown.enter)="createNewTicket()"
            >
                Create note
            </button>
        </ng-container>
    </ng-container>
</ce-tile-basic>
